import { FC, useContext } from "react";

import { useAtomValue } from "jotai";

import { Form } from "@components/Form/Form";
import { FormProvider } from "@components/FormProvider/FormProvider";

import { Step1 } from "./components/Step1";
import { Step2 } from "./components/Step2";

import { currentStepAtom } from "./atoms/currentStep.atom";

import { IDemoRegistrationForm } from "@models/DemoRegistrationForm.model";

import FORM_DETAILS from "@jsons/FORM_DETAILS.json";
import { AuthContext } from "@components/AuthProvider/contexts/Auth.context";

export const DemoRegistrationFormRoute: FC = () => {
  const {
    authUser: { uid },
  } = useContext(AuthContext)!;
  const currentStep = useAtomValue(currentStepAtom);
  return (
    <FormProvider<IDemoRegistrationForm> uid={uid} formName="demo-registration">
      {({
        draft,
        isSaving,
        isSubmitted,
        isSavePending,
        onSubmit,
        onSaveChanges,
      }) => (
        <Form
          totalSteps={2}
          currentStep={currentStep}
          isSaving={isSaving}
          title={FORM_DETAILS.DemoRegistration.title}
          description={FORM_DETAILS.DemoRegistration.description}
        >
          {currentStep === 1 && (
            <Step1
              draft={draft}
              isSavePending={isSavePending}
              onChange={onSaveChanges}
            />
          )}
          {currentStep === 2 && (
            <Step2
              draft={draft}
              isSubmitted={isSubmitted}
              isSavePending={isSavePending}
              onSubmit={onSubmit}
              onChange={onSaveChanges}
            />
          )}
        </Form>
      )}
    </FormProvider>
  );
};
